<div class="z-index-101 fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full" *ngIf="show" (click)="closeModal($event)">
  <div class="relative top-20 mx-auto p-2 border w-1/3 shadow-lg rounded-md bg-white" (click)="$event.stopPropagation()">
    <div class="mt-1">
      <!-- Header -->
      <div class="flex items-center justify-between p-2  rounded-t dark:border-gray-600">
        <h3 *ngIf="title" class="text-xl font-semibold">
          {{title}}
        </h3>
        <button  (click)="closeModal($event)" type="button" class="end-2.5 text-gray-400 bg-transparent  rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" >
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span class="sr-only">Close modal</span>
        </button>
    </div>

      <!-- Body -->
      <div class="mt-1">
        <div class="modal-body">
          <ng-content></ng-content>
        </div>
      </div>

    </div>
  </div>
</div>
